import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import BelowThresholdContent from "components/pages/AdvancedAlertsPage/components/BelowThresholdContent";
import Classes, { Account } from "model";

export default function CaptureNotifiLegacyBalanceBelowThreshold2(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const account = Account.getDefaultBrandedAccountByType("checking");
    const dataObj = { account: account, selectedUserAccountID: "0", selectedUserAccountType: "phone", balanceThreshold: "100.00" };
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    // Sets the component to be used for the content
    .update([ "contentData" ], dataObj)
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], BelowThresholdContent)
    .submit();
    
    return <AdvancedAlertsPage data={ data } ui={ ui } />
}